export const URL_Screens = (`${process.env.REACT_APP_HOST}/screens`)
export const URL_ScreensCorporate = (`${process.env.REACT_APP_HOST}/screensCorporate`)
